import styled from 'styled-components';
import Slide from '../containers/Slide';
import AccentLine from '../widgets/AccentLine';
import GetEducationList from '../../data/education-list';
import { motion, useInView } from "framer-motion"
import React, { useRef } from 'react';
import SectionHeader from '../widgets/SectionHeader';
import AboutImg from '../../res/images/about-img.png';
import CheckmarkIcon from '../../res/icons/checkmark.svg';

const Container = styled.div.attrs({ className: "about-slide" })`
    width: 75%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0 6rem 0;

    #about-container {
        width: 100%;
        display: flex;
        gap: 6rem;
    
        #left-of-about-container {
            position: relative;
            background-image: url(${AboutImg});
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            box-sizing: border-box;
            border-top: 12px dashed var(--brand);
            border-left: 6px dotted var(--yellow);
            border-bottom-right-radius: var(--radius-lg);
            backdrop-filter: blur(10px);
            display: grid;
            gap: 12px;
            width: 400px;
            aspect-ratio: 1 / 1;
            flex-shrink: 0;
            // box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
        }

        #right-of-about-container {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 2rem;

            h4 {
                color: var(--yellow);
                font-weight: normal;
                font-style: italic;
                font-size: 1.2rem;
            }

            h3 {
                color: var(--brand);
                font-size: 2.4rem;
                font-weight: normal;
            }

            p {
                padding: 0 1rem;
                box-sizing: border-box;
                font-size: 1.2rem;
                line-height: 1.8rem;
            }

            & > p {
                border-left: 4px solid var(--yellow);
            }

            .about-bullet {
                display: flex;
                align-items: center;
                gap: 1rem;

                .about-bullet-img {
                    width: 3rem;
                    height: 3rem;
                    background: var(--brand-2);
                    border-radius: 3rem;
                    background-image: url(${CheckmarkIcon});
                    background-size: 60%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
            }
        }
    }

    @media screen and (max-width: 980px) {
        height: auto;

        
    }

    @media screen and (max-width: 650px) {
        width: 100%;
        box-sizing: border-box;
        padding: 0 2rem 6rem 2rem;

        #about-container {
            flex-direction: column;
            align-items: center;
            gap: 4rem;

            #left-of-about-container {
                width: 100%;
            }
        }
    }
`

export default function AboutSlide() {

    /*
        The animation is conditional on the window's innerWidth (in coordination with the CSS media queries).
        If desktop, stagger the li's via the parent.
        If mobile, the parent stagger is discarded, and each li is responsible for its own animation.

        This was done to give that 'each item appears individually' feel.
    */

    const divAnim1 = {
        hidden: { opacity: 0, left: '-100px' },
        visible: { opacity: 1, left: '0' }
    }

    const divAnim2 = {
        hidden: { opacity: 0, right: '-100px' },
        visible: { opacity: 1, right: '0' }
    }

    // One ref and useInView for each education item
    const divRef1 = useRef(null);
    const divInView1 = useInView(divRef1, { once: true });

    const divRef2 = useRef(null);
    const divInView2 = useInView(divRef2, { once: true });

    const divRefArr = [
        { ref: divRef1, inView: divInView1 },
        { ref: divRef2, inView: divInView2 }
    ];

    // One ref and useInView for each education item
    const divRef = useRef(null);
    const divInView = useInView(divRef, { once: true })

    return (
        <Slide color="linear-gradient(180deg, transparent, rgba(14, 134, 204, .06));" height="auto" freeHeightBreakpoint="980px">

            <Container>

                <SectionHeader title="About" id="about-section" />

                <div id='about-container'>

                    <motion.div 
                        id='left-of-about-container'
                        ref={divRef1}
                        initial={divAnim1.hidden}
                        animate={divInView1 ? divAnim1.visible : divAnim1.hidden}
                        transition={{ delay: 0.3, delayChildren: 0.2, staggerChildren: 0.12 }}
                    >

                    </motion.div>

                    <motion.div 
                        id='right-of-about-container'
                        ref={divRef2}
                        initial={divAnim2.hidden}
                        animate={divInView2 ? divAnim2.visible : divAnim2.hidden}
                        transition={{ delay: 0.3, delayChildren: 0.2, staggerChildren: 0.12 }}
                    >

                        <AccentLine width="75px" color='var(--muted)' />
                        <AccentLine width="150px" color='var(--muted)' />

                        <h4>
                            Who is Flooring Covering Services LLC?
                        </h4>

                        <h3>
                            We are South Florida's #1 provider of tiling services.
                        </h3>

                        <p>
                            We specialize in the installation of all tile types, including, ceramic, laminate, mosaic, and more!
                            We offer the most affordable pricing around.
                        </p>

                        <AccentLine width="100%" color='var(--light-gray)' />

                        <div className='about-bullet'>
                            <div className='about-bullet-img'></div>
                            <p> Affordable pricing </p>
                        </div>

                        <div className='about-bullet'>
                            <div className='about-bullet-img'></div>
                            <p> High quality work </p>
                        </div>

                        <div className='about-bullet'>
                            <div className='about-bullet-img'></div>
                            <p> Satisfaction guaranteed </p>
                        </div>

                    </motion.div>

                </div>

            </Container>

        </Slide>
    )
}